const translations = {
  page_title: 'Deals',

  deals_found_n: 'Deals found: {{n}}',
  deals_found_0: 'No deals found',
  search_placeholder: 'Search by make, model or VIN',
  new_deal: 'New deal',

  no_deals_search: 'There are no deals that match your search',
  no_deals: 'There are no deals yet',

  image: 'Image',
  created_at: 'Started',
  updated_at: 'Last updated',
  client: 'Client',
  seller: 'Seller',
  make_model_trim: 'Make / Model / Trim',
  vin: 'VIN',
  stock_number_hash: 'Stock #',
  condition: 'Condition',
};

export default translations;